import httpService from "./http_service";
let publicHostName = "https://www.ciwei.com/api/api.php?do=";

export default {
  async areaList(data) {
    const url = publicHostName+`area_list`
    return await httpService.post(url, data)
  },
  async boiCreate(data) {
    const url = publicHostName+`boi_create`
    return await httpService.post(url, data)
  },
  // 预警提醒列表
  async noticeList(data) {
    const url = publicHostName+`rt_notice_list`
    return await httpService.post(url, data)
  },
  // 预警提醒详情
  async noticeInfo(data) {
    const url = publicHostName+`rt_notice_info`
    return await httpService.post(url, data)
  },
  // 安全快讯列表
  async secInfoList(data) {
    const url = publicHostName+`rt_sec_info_list`
    return await httpService.post(url, data)
  },
  // 安全快讯详情
  async secInfoInfo(data) {
    const url = publicHostName+`rt_sec_info_info`
    return await httpService.post(url, data)
  },
  // 风险前瞻
  async riskTrendList(data) {
    const url = publicHostName+`risk_trend_list`
    return await httpService.post(url, data)
  },
  // 社区列表
  async communityList(data) {
    const url = publicHostName+`community_list`
    return await httpService.post(url, data)
  }
}


// WEBPACK FOOTER //
// ./src/api/api.js